module.exports = __webpack_public_path__ + "media/5_6.09ef864b.wav";